const SubAbasFornecedores = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/fornecedor/adm/fornecedores/ficha/${id}/dadosgerais`,
  },
  /*{
    label: 'Representantes',
    rota: `/daf/fornecedores/fornecedores/ficha/${id}/representantes`,
  },*/
  /* {
    label: 'Representantes',
    rota: `/fornecedor/adm/fornecedores/ficha/${id}/pr`,
  },*/
  {
    label: 'Histórico de Registro',
    rota: `/fornecedor/adm/fornecedores/ficha/${id}/historicort`,
  },
  {
    label: 'Registro de Comunicações',
    rota: `/fornecedor/adm/fornecedores/ficha/${id}/comunicacoes`,
  },
];

export default SubAbasFornecedores;
